module.exports = __webpack_public_path__ + "img/ar.f6b35ea5.svg";